import { ButtonPrimary } from 'components/Button'
import { AutoColumn } from 'components/Column'
import { CardSection } from 'components/earn/styled'
import { RowBetween } from 'components/Row'
import { LINKS } from 'constants/links'
import React from 'react'
import styled from 'styled-components'
import { TYPE } from 'theme'
import ModalWithCat from './ModalWithCat'
import TagButton from 'components/TagButton'

const Wrapper = styled.div`
  width: 100%;
  b {
    color: ${({ theme }) => theme.primary1};
  }
  p {
    color: ${({ theme }) => theme.text2};
    font-size: 14px;
    margin: 0;
  }

  img {
    width: 40px;
  }
`

const DiscordModal = () => {
  const [isOpen, setIsOpen] = React.useState(false)

  React.useEffect(() => {
    const hasSeen = localStorage.getItem('hasSeenDiscordModal')
    window.addEventListener('storage', () => {
      if (!hasSeen) {
        setIsOpen(true)
      }
    })
  }, [])

  const handleClose = () => {
    localStorage.setItem('hasSeenDiscordModal', 'true')
    setIsOpen(false)
  }

  return (
    <>
      <ModalWithCat isOpen={isOpen} onDismiss={() => handleClose()} cat>
        <Wrapper>
          <AutoColumn>
            <CardSection gap="md" style={{ position: 'relative', padding: '36px 32px 18px 32px' }}>
              <div style={{ position: 'absolute', right: '10px', top: '12px' }}>
                <TagButton onClick={() => handleClose()} style={{ border: 'none' }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icons-tabler-outline icon-tabler-x"
                    style={{ marginRight: '0' }}
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M18 6l-12 12" />
                    <path d="M6 6l12 12" />
                  </svg>
                </TagButton>
              </div>
              <RowBetween>
                <TYPE.white fontWeight={700} fontSize={20}>
                  Welcome to <b>HyperSwap Exchange!</b> 🎉
                </TYPE.white>
              </RowBetween>
              <p>
                Thank you for joining our platform. Join our community on Discord to stay updated with the latest
                features, announcements, and support!
              </p>
              <RowBetween style={{ gap: '12px', marginTop: '8px' }}>
                <ButtonPrimary
                  onClick={() => {
                    window.open(LINKS.discord.link, '_blank')
                  }}
                >
                  Join Discord
                </ButtonPrimary>
                <ButtonPrimary
                  onClick={() => {
                    window.open(LINKS.twitter.link, '_blank')
                  }}
                >
                  Join Twitter
                </ButtonPrimary>
              </RowBetween>
            </CardSection>
          </AutoColumn>
        </Wrapper>
      </ModalWithCat>
    </>
  )
}
export default DiscordModal
